import { createRoutine } from 'redux-saga-routines';

import { GET_ARTICLE } from './constants';

export const getArticle = createRoutine(GET_ARTICLE);
